import { createClient } from 'contentful';

export default createClient({
  space: 'yiht275v448t',
  accessToken: '249df7651fc18730ddb65c0e83c0eac73bd7c4827dbf26a332cce57fdcd25f7f',
  resolveLinks: false,
});



// WEBPACK FOOTER //
// ./src/constants/contentfulClient.js